<template>
  <v-text-field
    :id="name" :name="name"
    :label="label" :data-vv-as="label" :prepend-icon="icon"
    v-model="inputVal" :required="required"
    v-validate="validation" :error-messages="errors.collect(name)" :autofocus="autofocus"/>
</template>

<script>
export default {
  inject: ['$validator'],
  name: 'edit-field',
  props: {
    icon: { type: String, default: '' },
    label: { type: String, default: '' },
    validation: { default: 'required' },
    required: { type: Boolean, default: true },
    value: '',
    autofocus: false
  },
  computed: {
    name () {
      return this.label.toLowerCase().replace(/ /g, '_')
    },
    inputVal: {
      get () {
        return this.value
      },
      set (s) {
        this.$emit('input', s)
      }
    }
  },
  mounted () {
    this.$validator.extend('begins', {
      getMessage: (field, args) => field + ' must begin with ' + args,
      validate: (value, args) => value.indexOf(args) === 0
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/edit-field.vue